var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0V0C62.0914 0 80 17.9086 80 40V40C80 62.0914 62.0914 80 40 80V80C17.9086 80 0 62.0914 0 40V40Z",
    fill: "url(#paint0_linear_626_3027)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1861 18.1776C52.3931 15.7605 47.6719 15 41.0167 15H27.5V18.8661H40.7402C46.7501 18.8661 50.4702 19.4189 53.4707 21.2852C54.9346 22.1593 56.131 23.3942 56.9358 24.8628C57.7406 26.3313 58.1252 27.9804 58.0499 29.6401C58.1071 31.2306 57.7508 32.8095 57.0135 34.233C56.2762 35.6564 55.1812 36.8791 53.8287 37.7895C51.2518 39.516 48.1018 40.4163 40.7332 40.4163H27.5V65H31.8659V44.1446H40.2375C47.323 44.1446 52.5447 43.454 56.4101 40.8971C58.3387 39.6486 59.9081 37.949 60.9721 35.9569C62.0361 33.9647 62.5598 31.7448 62.4946 29.5045C62.5519 27.2505 62.0005 25.0209 60.8944 23.0349C59.7883 21.049 58.1656 19.375 56.1861 18.1776V18.1776Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_626_3027",
    x1: 56,
    y1: -0.00000176765,
    x2: 37.25,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A125E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyWallet);
export default __webpack_public_path__ + "static/media/poly-wallet.c87a631a5bca7a87b13eaa9b561cf16d.svg";
export { ForwardRef as ReactComponent };